import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-questionnaires',
  templateUrl: './questionnaires.component.svg',
})
export class QuestionnairesComponent extends MedrecordIcon {
  viewHeight = 24;
  viewWidth = 24;
}
